module.exports = __webpack_public_path__ + "p5_img2.jpg?b1c31b3239e4a661aabf912b4ed0bedb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p5/p5_img2.jpg
// module id = 57
// module chunks = 0